<template>
  <div class="fill-height pa-0 " style="background: #F6F9FC">
    <!--    <v-fade-transition mode="out-in">-->
    <!--      <MainMobileMenu @openSupportChat="openSupportChat" v-if="isMobile"/>-->
    <!--      <div class="overlayNav" v-if="isMobile && isOverlay ">-->
    <!--        <v-app-bar elevation="0" color="transparent" class="d-flex justify-end" fixed>-->
    <!--          <img src="../assets/icons/BackButten.svg" alt="" @click="backRouter" id="backOverlay">-->
    <!--        </v-app-bar>-->
    <!--      </div>-->
    <!--    </v-fade-transition>-->
    <!--    <div class="cartIcon d-flex" :class="!$vuetify.rtl ? 'rtl_cartIcon' : 'ltr_cartIcon'"-->
    <!--         v-if="!isMobile">-->
    <!--      <router-link :to="{name:'basket'}" v-if="!isMobile">-->
    <!--        <div>-->
    <!--          <v-btn x-small fab elevation="0" color="transparent">-->
    <!--            <img src="../assets/icons/backet.png" width="20px" alt="">-->
    <!--          </v-btn>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <img src="../assets/notifyCartAssetes.svg" v-if="cartLength != 0" class="havePackage" alt="">-->
    <!--        </div>-->
    <!--      </router-link>-->
    <!--&lt;!&ndash;      <div @click="openSupportChat" class="mr-1">&ndash;&gt;-->
    <!--&lt;!&ndash;        <v-btn x-small fab elevation="0" color="transparent">&ndash;&gt;-->
    <!--&lt;!&ndash;          <v-icon>mdi-message-outline</v-icon>&ndash;&gt;-->
    <!--&lt;!&ndash;        </v-btn>&ndash;&gt;-->
    <!--&lt;!&ndash;      </div>&ndash;&gt;-->
    <!--    </div>-->
    <!--    <v-fade-transition>-->
    <!--      <div class="SupportMessenger" v-if="showMessenger">-->
    <!--        <SupportChatSidebar @closeSupportChatSidebar="closeSupportChatSidebar"/>-->
    <!--      </div>-->
    <!--    </v-fade-transition>-->
    <!--    <div class="fill-height pa-0 " :class="!isMobile && 'row'">-->
    <!--      <v-col cols="12" lg="1" class="pa-0" v-if="!isMobile">-->
    <!--        <div class="fill-height sidebarArea">-->
    <!--          <MainSidebar/>-->
    <!--        </div>-->
    <!--      </v-col>-->
    <!--      <v-col cols="12" md="12" style="background: white !important;" :class="!isMobile && 'pr-10'"-->
    <!--             lg="11">-->
    <!--        <div class="routerArea  fill-height d-flex flex-column mt-13" style="position: relative">-->
    <!--          <div class="routerInfo  text-right" :style="$vuetify.rtl && 'margin-left: 8%'"-->
    <!--               v-if="!isMobile">-->
    <!--            <div class="welcomeMessage " :class="!$vuetify.rtl && 'text-left'">-->
    <!--              {{ $t('welcome') }}-->
    <!--            </div>-->
    <!--            <div class="routeName " :class="!$vuetify.rtl && 'text-left'">-->
    <!--              <template v-if="!$route.meta.patentRoute">-->
    <!--                {{ $t(`routes.${$route.meta.routeKey}`) }}-->
    <!--              </template>-->
    <!--              <template v-else>-->
    <!--                <div class="panelRoute d-flex justify-start ">-->
    <!--                  <div class="parentRoute font-weight-bold">-->
    <!--                    <router-link :to="{name:'dashboard'}">-->
    <!--                      {{ $t(`routes.${$route.meta.patentRoute}`) }}-->
    <!--                    </router-link>-->
    <!--                  </div>-->
    <!--                  <div style="transform: rotate(180deg)" class=" parentRoute">-->
    <!--                    <v-icon>-->
    <!--                      mdi-menu-right-->
    <!--                    </v-icon>-->
    <!--                  </div>-->
    <!--                  <div>-->
    <!--                    {{ $t(`routes.${$route.meta.routeKey}`) }}-->
    <!--                  </div>-->
    <!--                  <div style="transform: rotate(180deg)" class="mx-2 parentRoute">-->
    <!--                  </div>-->

    <!--                </div>-->
    <!--              </template>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="routerBody flex-grow-1" id="routerArea" :class="{'overlayRoute':isOverlay}">-->
    <!--            <v-fade-transition mode="out-in">-->
    <!--              <router-view/>-->
    <!--            </v-fade-transition>-->
    <!--          </div>-->
    <!--          <div class="footer mt-5 pb-5"-->
    <!--               :class="{'rtl_footer':!$vuetify.rtl,'ltr_footer':$vuetify.rtl}"-->
    <!--               v-if="!isOverlay">-->
    <!--            <v-divider style="background: #f8f9fb"></v-divider>-->
    <!--            <div class="footerItems mt-5 d-flex justify-end">-->
    <!--              <div class="footerItem">-->
    <!--                copyright 2022 {{ getDomainPlatform() }} All Rights Reserved ©-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </v-col>-->
    <!--    </div>-->
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <div class="topHeader white">
         <div class="d-flex justify-space-between " :class="!$vuetify.rtl ?? 'flex-row-reverse'">
          <div class="logoArea d-flex justify-center flex-column">
            <div>
              <router-link :to="{name:'dashboard'}">
                <img src="../assets/logo/LogoGreen.png" alt="" style="width: 70px" v-if="getPlatformInfo('id') == 3">
                <p v-else-if="getPlatformInfo('id')" class="primary--text" style="text-align: center">{{
                    getPlatformTitle()
                  }}</p>
              </router-link>
            </div>
          </div>
          <div class="d-flex justify-center flex-column ml-13">
            <router-link :to="{name:'basket'}" v-if="!isMobile">
              <div>
                <v-btn x-small fab elevation="0" color="transparent">
                  <img src="../assets/icons/menu/cart.svg" width="20px" alt="">
                </v-btn>
              </div>
              <div class="">
                <!--                <img src="../assets/icons/menu/cart.svg" v-if="cartLength != 0" class="havePackage" alt="">-->
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="routeBodyContext  fill-height">
        <v-row class="fill-height ">
          <v-col cols="12" md="1" lg="1" class="fill-height">
            <div class="sidebarMenu  fill-height d-flex flex-column" :style="$vuetify.rtl ? 'right: 0 !important' : 'left: 0 !important'" >
              <div>
                <div class="" v-for="(item ,i) in filteredMenuItems" :key="i">
                  <router-link :to="item.route">
                    <div class="menuItem" :class="item.key == $route.name  && 'activeMenuItem'">
                      <div class="imageMenuItem">
                        <img :src="item.icon" alt="" v-if="item.key != $route.name">
                        <img :src="item.active_icon" v-else>
                      </div>
                      <div class="textMenuItem">
                        {{ item.title }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <v-spacer></v-spacer>
              <div class="menuItem" @click="logout">
                <div class="imageMenuItem">
                  <img src="../assets/icons/menu/logout.svg" alt="">
                </div>
                <div class="textMenuItem">
                  {{$t("menu.exit")}}

                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="11" lg="11" class="">
            <div class="fill-height" style="padding-top: 100px">
              <div class="routerArea   fill-height">
                <div class="titleRoute">
                  {{ $t(`routes.${$route.meta.routeKey}`) }}
                </div>
                <div v-if="$route.name === 'dashboard' && !isChatDisabled" class="helpBanner mt-2">
                  <div class="helpBanner-content">
                    <div class="helpBanner-text">
                      <v-icon color="#6B7FD7" size="20" class="mr-2">mdi-help-circle</v-icon>
                      <span>برای هماهنگی جلسات، می‌توانید از طریق  پشتیبانی برای ما پیام بفرستید.</span>
                    </div>
                    <v-btn
                      color="#6B7FD7"
                      dark
                      small
                      @click="$router.push({ name: 'support-chat', params: { lang: 'fa' } })"
                      class="helpBanner-btn"
                    >
                      <v-icon left small>mdi-message-text</v-icon>
                      چت پشتیبانی
                    </v-btn>
                  </div>
                </div>
                <div class="routerBox ">
                  <v-fade-transition mode="out-in">
                    <router-view/>
                  </v-fade-transition>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-else>
      <div class="mobileHeader d-flex justify-center flex-column" v-if="!isSupportChat">
        <div class="d-flex justify-space-between px-5">
          <div class="pt-1">
            <v-icon @click="drawer = true" color="black">mdi-menu</v-icon>
          </div>
          <div class="d-flex justify-center flex-column">
            <router-link to="/">
              <img v-if="getPlatformInfo('id') == 3" src="../assets/logo/LogoGreen.png" width="50px" alt="">
              <p v-else-if="getPlatformInfo('id')" style="color: white;text-align: center">{{
                  getPlatformTitle()
                }}</p>
            </router-link>
          </div>
          <div class="d-flex justify-center flex-column">
            <router-link to="/fa/panel/basket">
              <img src="../assets/icons/menu/cart.svg" alt="">
            </router-link>
          </div>
        </div>
      </div>
      <v-navigation-drawer
          v-if="!isSupportChat"
          v-model="drawer"
          app
          right
          width="100%"
      >
        <div class="d-flex flex-column fill-height">
          <div class="navbarHeader d-flex flex-column justify-center flex-column">
            <div class="d-flex justify-end">
              <v-icon @click="drawer = false" color="black">mdi-close</v-icon>
            </div>
          </div>
          <div class="menuItemsMobile flex-grow-1">
            <div v-for="(item , i) in filteredMenuItems" :key="i">
              <router-link :to="item.route">
                <div class="menuItemMobile d-flex flex-column justify-center"
                     :class="item.key == $route.name && 'activeMenuItemMobile'">
                  <div class="d-flex">
                    <div class="imageMenuItemMobile">
                      <img :src="item.icon" alt="" v-if="item.key != $route.name">
                      <img :src="item.active_icon" v-else>
                    </div>
                    <div class="textMenuItemMobile flex-grow-1 ml-3">
                      {{ item.title }}
                    </div>
                    <div class="actionMenuItemMobile">
                      <img
                          :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"
                          src="../assets/icons/menu/chevron-left.svg" v-if="item.key != $route.name" width="20" alt="">
                      <img
                          :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"
                          src="../assets/icons/menu/chevron-left_active.svg" v-else width="20" alt="">
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="menuItemMobile d-flex flex-column justify-center" @click="logout">
              <div class="d-flex">
                <div class="imageMenuItemMobile">
                  <img src="../assets/icons/menu/logout.svg" alt="">
                </div>
                <div class="textMenuItemMobile flex-grow-1 ml-3">
                  {{$t("menu.exit")}}
                </div>
              </div>
            </div>
          </div>
<!--          <div class="logoutBtn">-->
<!--            <div class="d-flex">-->
<!--              <div class="imageMenuItemMobile">-->
<!--                <img src="../assets/icons/menu/logout.svg" alt="">-->
<!--              </div>-->
<!--              <div @click="logout" class="textMenuItemMobile flex-grow-1">-->
<!--                خروج از حساب-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>

      </v-navigation-drawer>
      <div class="fill-height" :style="{paddingTop: isSupportChat ? '0px' : '65px'}">
        <div class="routerArea fill-height" :class="{'routerArea--full': isSupportChat}">
          <div v-if="!isSupportChat">
            <div class="titleRoute">
              {{ $t(`routes.${$route.meta.routeKey}`) }}
            </div>
            <div v-if="$route.name === 'dashboard' && !isChatDisabled" class="helpBanner">
              <div class="helpBanner-content">
                <div class="helpBanner-text">
                  <v-icon color="#6B7FD7" size="18" class="mr-2">mdi-help-circle</v-icon>
                  <span>برای هماهنگی جلسات، می‌توانید از طریق  پشتیبانی برای ما پیام بفرستید.</span>
                </div>
                <v-btn
                  color="#6B7FD7"
                  dark
                  x-small
                  @click="$router.push({ name: 'support-chat', params: { lang: 'fa' } })"
                  class="helpBanner-btn"
                >
                  <v-icon left x-small>mdi-message-text</v-icon>
                  چت پشتیبانی
                </v-btn>
              </div>
            </div>
          </div>
          <div class="routerBox" :class="{'routerBox--full': isSupportChat}">
            <v-fade-transition mode="out-in">
              <router-view/>
            </v-fade-transition>
          </div>
        </div>
      </div>
    </template>

    <button
      v-if="!isSupportChat && !isChatDisabled"
      class="floating-support-btn"
      @click="$router.push({ name: 'support-chat', params: { lang: 'fa' } })"
      aria-label="پشتیبانی"
      type="button"
    >
      <img src="../assets/icons/menu/messengerIcon.svg" alt="chat" />
    </button>
  </div>
</template>

<script>
import MainSidebar from "@/components/Sidebar/MainSidebar";
import MainMobileMenu from "@/components/Navbar/MainMobileMenu";
import {mapGetters} from "vuex";
import SupportChatSidebar from "@/components/Messeges/SupportChatSidebar";
import { isChatDisabledTimezone } from "@/utils/chatTimezone";
/*eslint-disable*/
export default {
  components: {SupportChatSidebar, MainMobileMenu, MainSidebar},
  data() {
    return {
      showMessenger: false,
      isMobile: true,
      drawer: false,
      isChatDisabled: isChatDisabledTimezone(),
      menuItems: [
        {
          icon: require('../assets/icons/menu/dashboard.svg'),
          active_icon: require('../assets/icons/menu/dashboard_active.svg'),
          title: this.$t("menu.dashboard"),
          key: 'dashboard',
          route: {
            name: 'dashboard',
          }
        },
        {
          icon: require('../assets/icons/menu/user.svg'),
          active_icon: require('../assets/icons/menu/user_active.svg'),
          title: this.$t("menu.profile"),
          key: "setting",
          route: {name: 'setting'},
        },
        {
          icon: require('../assets/icons/menu/box.png'),
          active_icon: require('../assets/icons/menu/box_active.png'),
          title: this.$t("menu.packages"),
          key: "packages",
          route: {
            name: 'packages',
          }
        },
        {
          icon: require('../assets/icons/menu/session.svg'),
          active_icon: require('../assets/icons/menu/session_active.svg'),
          title: this.$t("menu.sessions"),
          key: "sessions",
          route: {
            name: 'sessions',
          }
        },
        {
          icon: require('../assets/icons/menu/monitor.svg'),
          active_icon: require('../assets/icons/menu/monitor_active.svg'),
          title: this.$t("menu.session_request"),
          key: 'sessions-request',
          route: {name: 'sessions-request',}
        },
        {
          icon: require('../assets/icons/menu/payment.svg'),
          active_icon: require('../assets/icons/menu/payment_active.svg'),
          title: this.$t("menu.finance"),
          key: "wallet",
          route: {
            name: 'wallet',
          },
        },
        {
          icon: require('../assets/icons/menu/test.svg'),
          active_icon: require('../assets/icons/menu/test_active.svg'),
          title: this.$t("menu.tests"),
          key: "tests",
          allowed_platform: [3],
          route: {
            name: 'tests',
          }
        },
        {
          icon: require('../assets/icons/menu/test.svg'),
          active_icon: require('../assets/icons/menu/test_active.svg'),
          title: this.$t("menu.feedback"),
          key: "myoutcome",
          allowed_platform: [3],
          route: {
            name: 'myoutcome',
          }
        },
        // {
        //   icon: require('../assets/icons/packages.svg'),
        //   title: 'خرید‌ جلسه',
        //   key: "packages",
        //   route: {
        //     name: 'packages',
        //   }
        // },


        // {
        //   icon: require('../assets/icons/tasks.svg'),
        //   title: 'تسک‌ها',
        //   key: "tasks",
        //   route: {
        //     name: 'tasks',
        //   }
        // },

        {
          icon: require('../assets/icons/menu/message_fit.svg'),
          active_icon: require('../assets/icons/menu/message_active_fit.svg'),
          title: 'پیام‌ها',
          key: 'support-chat',
          route: { name: 'support-chat' }
        },
        // {
        //   icon: require('../assets/icons/messengerIcon.svg'),
        //   title: 'پیام‌ها',
        //   key: "messenger",
        //   route: {
        //     name: 'messenger',
        //   }
        // },


        // {
        //   icon: require('../assets/icons/invitees.png'),
        //   title: 'دعوت‌ها',
        //   key: "invitees",
        //   route: {name: 'invitees'}
        // },
        // {
        //   icon: require('../assets/icons/File.svg'),
        //   title: 'پرونده‌',
        //   key: "file",
        //   route: {
        //     name: 'profile',
        //     query: {
        //       step: 'medical'
        //     }
        //   }
        // },

      ]

    }
  },
  methods: {
    openSupportChat() {
      if (this.isChatDisabled) {
        return
      }
      this.$router.push({ name: 'support-chat' })
      // this.showMessenger = true
    },
    closeSupportChatSidebar() {
      this.showMessenger = false
    },
    backRouter() {
      switch (this.$route.name) {
        case "support-chat":
          this.$router.push({name: 'dashboard'})
          break;
        default:
          this.$router.back()
          break
      }
    },
    prepareSize() {
      const windowWidth = window.innerWidth
      this.isMobile = windowWidth < 1500
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart'
    }),
    isSupportChat() {
      return this.$route.name === 'support-chat';
    },

    cartLength() {
      if (this.cart) {
        return Object.keys(this.cart.items).length
      } else {
        return 0;
      }
    },
    filteredMenuItems() {
      const platformId = this.platFormInfoLS?.id;
      return this.menuItems.filter(item => {
        if (item.key === 'support-chat' && this.isChatDisabled) {
          return false;
        }
        if (!item.allowed_platform) {
          return true;
        }
        return item.allowed_platform.includes(platformId);
      });
    }
  },
  mounted() {
    this.$onEvent('openChatSupport', () => {
      this.openSupportChat();
    })
    this.prepareSize()
    window.addEventListener('resize', this.prepareSize);
  },
}
</script>

<style>
.logoutBtn {
  border-top: 1px solid #EAF0F6;
  height: 70px;
  margin-bottom: 10px;
  padding: 16px 32px;
}

.mobileHeader {
  background: white;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  height: 60px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
}

.navbarHeader {
  border-bottom: 1px solid #EAF0F6;
  height: 60px;
  padding: 32px;
}

.menuItemsMobile {
  padding: 32px;
}

.textMenuItemMobile {
  font-size: 13px;
  padding-right: 8px;
  padding-top: 3px;
}

.imageMenuItemMobile {
  width: 20px;
}

.menuItemMobile {
  padding: 15px 10px 10px 10px;
}

.activeMenuItemMobile {
  background: rgba(197, 239, 254, 0.50);
  border-radius: 8px;
  color: #035184;
}


a {
  color: inherit !important;
}

.titleRoute {
  font-size: 20px;
  height: 55px;
  display: flex;
  font-family: bold !important;
  padding: 24px;
  flex-direction: column;
  border-bottom: 1px solid #EAF0F6;;
  justify-content: center;
}

.routerBox {
  padding: 0px 24px
}

.routerArea--full {
  padding: 0 !important;
}

.routerBox--full {
  padding: 0 !important;
}

.helpBanner {
  margin: 0 24px 16px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #E8F0FF 0%, #F0F7FF 100%);
  border: 1px solid #6B7FD7;
  border-left: 4px solid #6B7FD7;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(107, 127, 215, 0.15);
}

.helpBanner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.helpBanner-text {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 14px;
  color: #1A2B5F;
  font-weight: 500;
}

.helpBanner-btn {
  flex-shrink: 0;
  text-transform: none;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(107, 127, 215, 0.3);
}

.helpBanner-btn:hover {
  box-shadow: 0 4px 12px rgba(107, 127, 215, 0.4);
  transform: translateY(-1px);
}

@media (max-width: 960px) {
  .helpBanner {
    margin: 0 16px 12px;
    padding: 12px 16px;
  }
  
  .helpBanner-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .helpBanner-text {
    font-size: 13px;
  }
  
  .helpBanner-btn {
    width: 100%;
    justify-content: center;
  }
}

.floating-support-btn {
  position: fixed;
  left: 16px;
  bottom: 16px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: #6B7FD7;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
}

.floating-support-btn img {
  width: 26px;
  height: 26px;
}
body {
  overflow: visible;
}

.activeMenuItem {
  transition: all 0.3s;
}

.menuItem {
  transition: all 0.3s;
}

.activeMenuItem .imageMenuItem {
  color: #035184;
  background: rgba(197, 239, 254, 0.50);
  border-radius: 4px;
  transition: all 0.3s;
}

.activeMenuItem .textMenuItem {
  color: #035184;
  transition: all 0.3s;
}

.imageMenuItem {
  width: 40px;
  height: 40px;
  margin: 0px auto;
  transition: all 0.3s;
}

.menuItem {
  margin-bottom: 20px;
}

.textMenuItem {
  font-size: 14px;
  margin-top: 3px;
}

.imageMenuItem {
  padding-top: 8px;
  transition: all 0.3s;
}

.routeBodyContext {
  /*padding-top: 100px;*/
}

.sidebarMenu {
  position: fixed;
  width: 120px;
  background: white;
  border-left: 1px solid #EAF0F6;
  padding-top: 100px;
  text-align: center;
  z-index: 1;
}

.topHeader {
  z-index: 2;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  height: 70px;
  position: fixed;
  right: 0;
  left: 0;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 24px;
}

@media (min-width: 200px) and (max-width: 600px) {
  .routerBody {
    margin-right: 0px !important;
    height: auto !important;
    min-height: 100vh !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
  }

  .overlayNav {
    margin-bottom: -50px;
  }

  .routerArea {
    height: auto !important;
    width: 100% !important;
  }

  .snackBarBasket {
    position: fixed !important;
    width: 70% !important;
    bottom: 100px !important;
    /*left: 10% !important;*/
    right: 15% !important;
  }

  .rtl_routeBody {
    margin-right: 0% !important;
  }

  .ltr_routeBody {
    margin-left: 0% !important;
  }

  .SupportMessenger {
    top: 0px !important;
    bottom: 10px !important;
    left: 0px !important;
    right: 0px !important;
    width: 100% !important;
  }
}

.SupportMessenger {
  width: 500px;
  z-index: 9999;
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px
}

.cartIcon {
  position: fixed;
  top: 15px;
  z-index: 9999;
}

.rtl_cartIcon {
  right: 15px;
}

.ltr_cartIcon {
  left: 15px;
}

.havePackage {
  position: absolute;
  top: -5px;
  right: -5px;
}

.footerItem {
  color: #1c53c1;
  font-size: 12px;
}

.footer {
  /*margin-right: 12%;*/
}

.rtl_footer {
  margin-right: 12%;
}

.ltr_footer {
  margin-left: 5%;
}

.routerBody {
  /*height: 85%;*/
  /*height: 100%;*/
  margin-top: 10px;
  background: linear-gradient(90deg, white 21px, transparent 0%) center,
  linear-gradient(#ffffff 21px, transparent 0%) center,
  #e2d9f7;
  background-size: 23px 23px;
  /*overflow-y: auto;*/
  /*overflow-x: hidden;*/
}

.rtl_routeBody {
  margin-right: 12%;
}

.ltr_routeBody {
  margin-left: 5%;
}

.welcomeMessage {
  color: #6d6d6d;
  font-size: 14px;
}

.routeName {
  font-size: 17px;
  color: #000;
  margin-top: 5px;
}

.routerArea {
  /*height: 100vh;*/
  width: 95%;
  border: 1px solid #EAF0F6;
  border-radius: 8px;
  background: white;
}

.sidebarArea {
  background: #f8f9fb;
  border-radius: 0px 30px 30px 0px !important;
  margin-top: 10px;
  height: 99%;
}

.parentRoute {
  color: #46b1a1;
  text-decoration: none;
}

a {
  text-decoration: none;
}

.snackBarBasket {
  position: absolute;
  bottom: 50px;
  width: 350px;
  height: 50px;
  background: #4576d8;
  right: calc(50% - 125px);
  border-radius: 15px;
  padding: 10px;
}

.priceBox {
  width: 35px;
  border-radius: 10px;
  background: white;
}

.overlayRoute {
  /*padding-top: 100px;*/
}
</style>
